import { getAuthConfig } from './getAuthConfig'

export function getConfig() {
  const config = getAuthConfig()
  const audience =
    config.audience && config.audience !== 'YOUR_API_IDENTIFIER'
      ? config.audience
      : undefined

  return {
    domain: config.domain,
    clientId: config.clientId,
    appOrigin: config.appOrigin,
    audience,
    organization: config.organization,
    connection: config.connection,
  }
}
